import { LocationPickerLocation, UnitStandard } from "@swivl-mono/types";
import { CarouselContext } from "pure-react-carousel";
import React from "react";

import { LanguageContext, t } from "../../../../../i18n/strings";
import { MetersToMiles } from "./MetersToMiles";

interface Props {
  canChangeZip: boolean;
  currentZip: string;
  setShouldFocusOnControl(control: string): void;
  searchRadiusInMeters?: number;
  locations?: LocationPickerLocation[];
  distanceUnit?: UnitStandard;
}
export const HeaderWithContext: React.FC<Props> = (props) => {
  const language = React.useContext(LanguageContext);
  const carouselContext = React.useContext(CarouselContext);
  const [currentSlide, setCurrentSlide] = React.useState(carouselContext.state.currentSlide);
  const onRadiusClick = () => {
    carouselContext.setStoreState({ currentSlide: carouselContext.state.totalSlides - 1 });
    props.setShouldFocusOnControl("radius");
  };
  const onZipClick = () => {
    carouselContext.setStoreState({ currentSlide: carouselContext.state.totalSlides - 1 });
    props.setShouldFocusOnControl("zip");
  };
  React.useEffect(() => {
    function onChange() {
      setCurrentSlide(carouselContext.state.currentSlide);
    }
    carouselContext.subscribe(onChange);
    return () => carouselContext.unsubscribe(onChange);
  }, [carouselContext]);

  React.useEffect(() => {
    carouselContext.setStoreState({ currentSlide: 0 });
  }, [props.locations]);

  if (props.searchRadiusInMeters) {
    if (props.distanceUnit === UnitStandard.METRIC) {
      return (
        <div className={"scc-LocationPickerHeader swivl-linkContainer"}>
          {t("locationPickerLocationsWithin", language)} <a onClick={onRadiusClick}>{props.searchRadiusInMeters / 1000}</a>{" "}
          {t("locationPickerKmOf", language)} <a onClick={onZipClick}>{props.currentZip}</a>{" "}
        </div>
      );
    }
    return (
      <div className={"scc-LocationPickerHeader swivl-linkContainer"}>
        {t("locationPickerLocationsWithin", language)} <a onClick={onRadiusClick}>{MetersToMiles(props.searchRadiusInMeters)}</a>{" "}
        {t("locationPickerMilesOf", language)} <a onClick={onZipClick}>{props.currentZip}</a>{" "}
      </div>
    );
  }

  return (
    <div className={"scc-LocationPickerHeader swivl-linkContainer"}>
      {" "}
      {t("locationPickerLocationsNear", language)} <a onClick={onZipClick}>{props.currentZip}</a>
    </div>
  );
};
